export const deprecated_colorPalette = {
  primary: {
    10: '#101e2d',
    9: '#1b314b',
    8: '#294c73',
    7: '#3b6da5',
    6: '#5a8bc4',
    5: '#78a0ce',
    4: '#96b5d9',
    3: '#b4cae4',
    2: '#d2dfef',
    1: '#f0f4fa',
  },
  neutral: {
    10: '#000000',
    9: '#1f1f1f',
    8: '#3d3d3d',
    7: '#525252',
    6: '#7a7a7a',
    5: '#999999',
    4: '#c2c2c2',
    3: '#e0e0e0',
    2: '#f2f2f2',
    1: '#ffffff',
  },
  secondary: {
    10: '#000000',
    9: '#171717',
    8: '#262626',
    7: '#525252',
    6: '#737373',
    5: '#a3a3a3',
    4: '#d4d4d4',
    3: '#e6e6e6',
    2: '#f5f5f5',
    1: '#fafafa',
  },
  warning: {
    10: '#451a03',
    9: '#92400e',
    8: '#b45309',
    7: '#d97706',
    6: '#f59e0b',
    5: '#fbbf24',
    4: '#fcd34d',
    3: '#fde68a',
    2: '#fef3c7',
    1: '#fffbeb',
  },
  success: {
    10: '#052e16',
    9: '#166534',
    8: '#15803d',
    7: '#16a34a',
    6: '#22c55e',
    5: '#4ade80',
    4: '#86efac',
    3: '#bbf7d0',
    2: '#dcfce7',
    1: '#f0fdf4',
  },
  danger: {
    10: '#450a0a',
    9: '#991b1b',
    8: '#b91c1c',
    7: '#dc2626',
    6: '#ef4444',
    5: '#f87171',
    4: '#fca5a5',
    3: '#fecaca',
    2: '#fee2e2',
    1: '#fef2f2',
  },
  info: {
    10: '#082f49',
    9: '#075985',
    8: '#0369a1',
    7: '#0284c7',
    6: '#0ea5e9',
    5: '#38bdf8',
    4: '#7dd3fc',
    3: '#bae6fd',
    2: '#e0f2fe',
    1: '#f0f9ff',
  },
} as const;
